import React, { useContext, useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, Typography,
  Box, IconButton, Divider, Grid, Table,
  TableHead, TableRow, TableCell, TableBody, Card, CardContent
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import RoomTypeRatePlanContext from '../contexts/RoomTypeRatePlanContext';

const DialogRateDetail = ({ open, handleClose, rateDetail }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery('(max-width:600px)');
  const [coin, setCoin] = useState('');
  const { cartItems } = useContext(RoomTypeRatePlanContext);

  useEffect(() => {
    if (Array.isArray(rateDetail) && rateDetail.length > 0) {
      if (cartItems && cartItems.length > 0) {
        const moneda = cartItems[0].CarritoItemMoneda;
        setCoin(moneda);
      }
    }
  }, [rateDetail, cartItems]);

  const formatDate = (date) => {
    const parsedDate = new Date(date);
    const day = parsedDate.getUTCDate();
    const month = parsedDate.getUTCMonth() + 1;
    const year = parsedDate.getUTCFullYear();
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  };

  const addOneDay = (dateStr) => {
    const date = new Date(dateStr);
    date.setDate(date.getDate() + 1);
    return formatDate(date);
  };

  const isTarifaPorHabitacion = Array.isArray(rateDetail) && rateDetail.every(item => item.CarritoItemAplica === 'H');
  const totalGeneral = Array.isArray(rateDetail)
    ? rateDetail.reduce((acc, item) => acc + parseFloat(item.CarritoItemTotal), 0)
    : 0;

  const startDate = Array.isArray(rateDetail) && rateDetail.length > 0 ? formatDate(rateDetail[0].CarritoItemFecha) : '';
  //const endDate = Array.isArray(rateDetail) && rateDetail.length > 0 ? formatDate(rateDetail[rateDetail.length - 1].CarritoItemFecha) : '';
  const endDate = Array.isArray(rateDetail) && rateDetail.length > 0 ? addOneDay(rateDetail[rateDetail.length - 1].CarritoItemFecha) : '';
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      maxWidth="lg"
      fullWidth={!fullScreen}
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          maxWidth: fullScreen ? '100%' : '900px',
        },
      }}
    >
      <DialogTitle id="responsive-dialog-title">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {Array.isArray(rateDetail) && rateDetail.length > 0 ? rateDetail[0].CarritoItemTarifa : 'Detalle de la tarifa'}
          <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom sx={{ fontWeight: 'bold' }}>
          Desglose de la tarifa con Checkin el {startDate} y Checkout el {endDate}
        </Typography>

        {Array.isArray(rateDetail) && rateDetail.length > 0 ? (!isMobile ? (
          <Table sx={{ width: '100%', borderCollapse: 'collapse' }}>
            <TableHead>
              <TableRow>
                <TableCell><strong>Fecha</strong></TableCell>
                {isTarifaPorHabitacion ? (
                  <TableCell align="center"><strong>Precio por noche</strong></TableCell>
                ) : (
                  <>
                    <TableCell align="center"><strong>Precio x Adultos</strong></TableCell>
                    <TableCell align="center"><strong>Precio x Niños</strong></TableCell>
                    <TableCell align="center"><strong>Total Noche</strong></TableCell>
                  </>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {[...new Set(rateDetail.map(item => item.CarritoItemFecha))].map(fecha => {
                const itemsDelDia = rateDetail.filter(item => item.CarritoItemFecha === fecha);
                if (isTarifaPorHabitacion) {
                  const total = itemsDelDia.reduce((acc, item) => acc + parseFloat(item.CarritoItemTotal), 0);
                  return (
                    <TableRow key={fecha}>
                      <TableCell>{formatDate(fecha)}</TableCell>
                      <TableCell align="center">{`${coin} ${total.toLocaleString('es-ES', { minimumFractionDigits: 2 })}`}</TableCell>
                    </TableRow>
                  );
                } else {
                  const totalAdultos = itemsDelDia
                    .filter(item => item.CarritoItemAplica === 'A')
                    .reduce((acc, item) => acc + parseFloat(item.CarritoItemTotal), 0);
                  const totalNinos = itemsDelDia
                    .filter(item => item.CarritoItemAplica === 'M')
                    .reduce((acc, item) => acc + parseFloat(item.CarritoItemTotal), 0);
                  const totalNoche = totalAdultos + totalNinos;
                  return (
                    <TableRow key={fecha}>
                      <TableCell>{formatDate(fecha)}</TableCell>
                      <TableCell align="center">{`${coin} ${totalAdultos.toLocaleString('es-ES', { minimumFractionDigits: 2 })}`}</TableCell>
                      <TableCell align="center">{`${coin} ${totalNinos.toLocaleString('es-ES', { minimumFractionDigits: 2 })}`}</TableCell>
                      <TableCell align="center">{`${coin} ${totalNoche.toLocaleString('es-ES', { minimumFractionDigits: 2 })}`}</TableCell>
                    </TableRow>
                  );
                }
              })}
            </TableBody>
          </Table>
        ) : (
          [...new Set(rateDetail.map(item => item.CarritoItemFecha))].map(fecha => {
            const itemsDelDia = rateDetail.filter(item => item.CarritoItemFecha === fecha);
            if (isTarifaPorHabitacion) {
              const total = itemsDelDia.reduce((acc, item) => acc + parseFloat(item.CarritoItemTotal), 0);
              return (
                <Card key={fecha} sx={{ mb: 2, p: 2, borderRadius: 2, boxShadow: 3 }}>
                  <CardContent>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {formatDate(fecha)}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Precio por noche:</strong> {coin} {total.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
                    </Typography>
                  </CardContent>
                </Card>
              );
            } else {
              const totalAdultos = itemsDelDia
                .filter(item => item.CarritoItemAplica === 'A')
                .reduce((acc, item) => acc + parseFloat(item.CarritoItemTotal), 0);
              const totalNinos = itemsDelDia
                .filter(item => item.CarritoItemAplica === 'M')
                .reduce((acc, item) => acc + parseFloat(item.CarritoItemTotal), 0);
              const totalNoche = totalAdultos + totalNinos;
              return (
                <Card key={fecha} sx={{ mb: 2, p: 2, borderRadius: 2, boxShadow: 3 }}>
                  <CardContent>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {formatDate(fecha)}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Precio x Adultos:</strong> {coin} {totalAdultos.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Precio x Niños:</strong> {coin} {totalNinos.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold', color: 'primary.main' }}>
                      Total Noche: {coin} {totalNoche.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
                    </Typography>
                  </CardContent>
                </Card>
              );
            }
          })
        )) : (
          <Typography variant="body2" color="textSecondary">
            No hay detalles disponibles para mostrar.
          </Typography>
        )}

        <Divider sx={{ my: 2 }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0' }}>
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            Total
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 'bold', textAlign: 'right' }}>
            {`${coin} ${totalGeneral.toLocaleString('es-ES', { minimumFractionDigits: 2 })}`}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DialogRateDetail;
